// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Checkbox,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Alert
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { withRouter, Link } from "react-router-dom";

import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";

import "../dashboard/dashboard.scss";
import { printVoucher } from "../../../redux/actions/frontActions";
import logo from "../../../img/ddb-logo.png";

import { appConfig } from "../../../config";

import { Notification } from "../../../components/notifications";

import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";

import ReactHtmlParser from "react-html-parser";

import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";

let Recaptcha = require("react-recaptcha");
let QRCode = require("qrcode.react");
let Barcode = require("react-barcode");

const history = createHashHistory();
let isLoading = "false";
class Voucher extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      show: false,
      voucher: "",
      hover: false,
    };

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
  }

  hoverOn = (e) => {
    if(e.target.attributes.getNamedItem("data-id").value){
      this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
    }
  }

  hoverOff = (e) => { 
    if(e.target.attributes.getNamedItem("data-id").value){
      this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });  
    }  
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  Clear() {
    this.setState({
      show: false
    });
  }

  handlePageChange = () =>{
    let voucherIDParams = this.props.route.match.params.voucherID ? this.props.route.match.params.voucherID : '';
    let type = this.props.route.match.params.type ? this.props.route.match.params.type : 'paid';
    if (voucherIDParams !== '')
    {
      isLoading="true";
      this.props.printVoucher(voucherIDParams, type);
    }
  };

  componentWillMount() {
    this.props.clearAlert();
    this.handleDismiss();
    this.handlePageChange();
    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }

    if (this.props.voucherDetail !== nextProps.voucherDetail) {
      if (nextProps.voucherDetail) {
        isLoading = "false";
        this.setState({ voucher: nextProps.voucherDetail });
      }
    }
  }

  componentWillUpdate(nextProps, nextState) {}

  printDiv = () => {
    let divToPrint = document.getElementById("DivIdToPrint");

    let newWin = window.open("", "Print-Window");

    newWin.document.open();

    newWin.document.write(
      '<html><body onload="window.print()">' +
        divToPrint.innerHTML +
        "</body></html>"
    );

    newWin.document.close();
  };

  render() {
    const style = {
      width: "100%",
      height: "100%"
    };

    var points = [
      { lat: 42.02, lng: -77.01 },
      { lat: 42.03, lng: -77.02 },
      { lat: 41.03, lng: -77.04 },
      { lat: 42.05, lng: -77.02 }
    ];
    var bounds = new this.props.google.maps.LatLngBounds();
    for (var i = 0; i < points.length; i++) {
      bounds.extend(points[i]);
    }

    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="container">
          <div className="panel margin-top">
            <header className="panel-heading">
              Voucher Detail{" "}
              <Button
                bsSize="small"
                className="pull-right"
                style={{backgroundColor: (this.state.hover && this.state.hoverID == 'order') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                data-id = 'order'
                onMouseEnter={this.hoverOn} 
                onMouseLeave={this.hoverOff}
                bsStyle="success"
                type="submit"
                onClick={this.printDiv.bind(this)}
              >
                <i className="fa fa-print" /> Print
              </Button>
            </header>
            <div className="panel-body" id="DivIdToPrint">
              {!isEmpty(this.state.voucher) ? (
                <Row>
                  <Col md={12} xs={12}>
                   {!isEmpty(this.state.voucher.template)
                    ? ReactHtmlParser(this.state.voucher.template)
                    : ""}
                  </Col>
                </Row>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Voucher.propTypes = {
  printVoucher: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  error: state.frontReducer.error,
  voucherDetail: state.frontReducer.voucherDetail,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default compose(
  GoogleApiWrapper({
    apiKey: "AIzaSyB9tFH-WZWM_pNZGg2OKiy2Ucde6xmUTQ0"
  }),
  connect(mapStateToProps, { printVoucher, renderAlert, clearAlert })
)(Voucher);



// WEBPACK FOOTER //
// ./src/app/views/frontend/user/Voucher.js